var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'view/transactions-report', 'component/range-selector', 'component/report/transactions-table', 'component/report/search', 'component/report/export-report', 'lib/search-query-parser', 'lib/moment', 'template/report/landing.htm', 'common/location'], function($, core, TransactionsReportView, rangeSelector, transactionsTable, search, reportExport, searchQuery, moment, landingTemplate, location) {
  var ReportSearchPage;
  return ReportSearchPage = (function(_super) {

    __extends(ReportSearchPage, _super);

    function ReportSearchPage() {
      ReportSearchPage.__super__.constructor.apply(this, arguments);
    }

    ReportSearchPage.prototype.pageId = 'search';

    ReportSearchPage.prototype.reportType = 'search';

    /*
    # @param {Object} meta contains id, title and icon
    	    # @param {string} searchString
    	    # @param {number|null} data
    */


    ReportSearchPage.prototype.initialize = function(options, params) {
      var id, url, _ref, _ref1, _ref2;
      params = params.map(core.decodeSearchString);
      if (((_ref = params[0]) != null ? _ref.toLowerCase().substring(0, 3) : void 0) === 'id:') {
        this.searchString = params[0];
      } else {
        this.searchString = decodeURIComponent((_ref1 = options.queryVals) != null ? _ref1.searchkey : void 0);
      }
      this.returnToPath = ((_ref2 = options.queryVals) != null ? _ref2.returl : void 0) || null;
      this.returnToName = options.returnToName || this.prettyPath(this.returnToPath);
      this.receiptsMode = false;
      if (this.searchString === 'undefined') {
        this.searchString = this.getSearchStringFromUrlParams();
      }
      this.setSearchQueries(this.searchString, options);
      url = function(clientId, searchString, page, ledgerId, from, to) {
        var encodedSearchString, optionalUrl, optionals;
        encodedSearchString = encodeURIComponent(searchString);
        optionals = [ledgerId, from, to];
        optionalUrl = optionals.map(function(val) {
          if (val) {
            return "/" + val;
          } else {
            return "";
          }
        }).join("");
        return "search/json/" + clientId + optionalUrl + "?page=" + page + "&results-per-page=50&pattern=" + encodedSearchString;
      };
      options = _.extend(options, {
        title: 'Search',
        icon: 'ss-list ss-standard',
        features: ['edit', 'search', 'date-range', 'overview'],
        template: landingTemplate,
        url: url
      });
      ReportSearchPage.__super__.initialize.call(this, options, params);
      this.data.currentLedgerId = !isNaN(params[0]) ? params[0] : null;
      this.currentLedgerText = this.data.currentLedgerId ? core.getLedgersById()[this.data.currentLedgerId].name : null;
      if (this.searchString === '') {
        if (this.returnToPath != null) {
          core.getRouter().loadPage(this.returnToPath);
        } else {
          core.getRouter().loadDefaultPage();
        }
        return;
      }
      if ((this.searchString.replace(/\s*:\s*/g, ":").toLowerCase()).substring(0, 3) === 'id:') {
        id = this.searchString.split(':')[1];
        return this.loadSpecificTransaction($.trim(id));
      } else {
        return this.loadData(this.pageNum, this.searchString);
      }
    };

    ReportSearchPage.prototype.initUI = function() {
      var prefix;
      ReportSearchPage.__super__.initUI.apply(this, arguments);
      this.showFeature('download');
      this.initExportReportLinks();
      $('.search-button').addClass('active');
      search.setSearchString(this.searchString);
      prefix = this.currentLedgerText != null ? " in " + this.currentLedgerText + ": " : ': ';
      $('.report-name').append(prefix + this.searchString);
      if (this.returnToPath && this.returnToName) {
        return this.initBackButtonFeature(this.returnToName, this.returnToPath);
      }
    };

    ReportSearchPage.prototype.initReportDateIntervals = function() {
      var end, endMarkerIndex, start, startMarkerIndex;
      startMarkerIndex = this.settings.params.indexOf('start');
      endMarkerIndex = this.settings.params.indexOf('end');
      if (startMarkerIndex >= 0 && endMarkerIndex >= 0) {
        start = this.settings.params[startMarkerIndex + 1];
        end = this.settings.params[endMarkerIndex + 1];
        return this.updateReportIntervalFromURL(start, end);
      } else {
        return this.updateReportURLFromInterval(this.settings.params);
      }
    };

    ReportSearchPage.prototype.initExportReportLinks = function() {
      return reportExport.updateLinksForSearch($('.download-button'), reportExport.SEARCH, this.searchString, this.data.currentLedgerId);
    };

    /*
    # @override
    */


    ReportSearchPage.prototype.prepareTransactionsUI = function(data, page, searchString) {
      var additionalText;
      ReportSearchPage.__super__.prepareTransactionsUI.apply(this, arguments);
      if (page === 1 && this.currentLedgerText) {
        additionalText = this.currentLedgerText;
      }
      if (page === 1 && this.receiptsMode) {
        additionalText = 'Unmatched Receipts';
      }
      if (additionalText) {
        return $('.report-name').addClass('extended').prepend("<div class='name-detail'>" + additionalText + "</div>");
      }
    };

    /*
    # @override
    */


    ReportSearchPage.prototype.getQueryParamsForTransactionsLoading = function(toPage, searchMode) {
      var parameters;
      parameters = ReportSearchPage.__super__.getQueryParamsForTransactionsLoading.apply(this, arguments);
      if (this.data.currentLedgerId != null) {
        parameters['ledger-id'] = this.data.currentLedgerId;
      }
      return parameters;
    };

    ReportSearchPage.prototype.searchAction = function(searchKey) {
      return this.searchLoad({
        queryVals: {
          returl: this.returnToPath,
          searchkey: searchKey
        }
      }, [this.data.currentLedgerId]);
    };

    /*
    # After pressing the 'ENTER' key when a search term has been typed,
    # the setSearchQueries function updates the url to include the search keywords and values as parameters.
    # Example - [ name:"direct deposit" more:100 implies ?name="direct deposit"&more=100 ]
    */


    ReportSearchPage.prototype.setSearchQueries = function(searchString, options) {
      var queryKey, searchOptions, searchQueryObj, searchQueryObjKeys, setUrlQuery, _i, _len, _ref, _ref1, _ref2, _ref3, _results;
      searchString = $.trim(searchString.replace(/\s*:\s*/g, ":").replace(/'/g, '"').toLowerCase());
      searchOptions = {
        keywords: ['name', 'amount', 'ledger', 'after', 'before', 'more', 'less', 'id']
      };
      searchQueryObj = searchQuery(searchString, searchOptions);
      searchQueryObjKeys = Object.keys(searchQueryObj);
      if (((searchQueryObj != null) && ((_ref = (searchQueryObj != null ? searchQueryObj.text : void 0)) != null ? _ref.length : void 0) > 0) && searchString.substring(0, 3) === !'id:') {
        if ((_ref1 = options.queryVals) != null) {
          _ref1['searchkey'] = searchQueryObj != null ? searchQueryObj.text : void 0;
        }
      } else if ((searchQueryObj != null) && typeof searchQueryObj === 'string' && searchQueryObj.length > 0) {
        if ((_ref2 = options.queryVals) != null) {
          _ref2['searchkey'] = searchQueryObj;
        }
      } else {
        if ((_ref3 = options.queryVals) != null) {
          delete _ref3['searchkey'];
        }
      }
      setUrlQuery = function(queryKey) {
        var queryValue, _ref4, _ref5;
        if ($.inArray(queryKey, searchOptions.keywords) > -1) {
          queryValue = searchQueryObj[queryKey];
          if ((queryKey === 'before') || (queryKey === 'after')) {
            queryValue = moment(queryValue, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYYMMDD", "YYYY.MM.DD"]);
            queryValue = queryValue.format("YYYY-MM-DD");
            if ((moment(queryValue).isValid()) && moment(queryValue).isAfter('1999-12-31')) {
              return (_ref4 = options.queryVals) != null ? _ref4[queryKey] = queryValue : void 0;
            }
          } else {
            return (_ref5 = options.queryVals) != null ? _ref5[queryKey] = queryValue : void 0;
          }
        }
      };
      _results = [];
      for (_i = 0, _len = searchQueryObjKeys.length; _i < _len; _i++) {
        queryKey = searchQueryObjKeys[_i];
        _results.push(setUrlQuery(queryKey));
      }
      return _results;
    };

    /*
    # getSearchStringFromUrlParams extracts params from the url of the page.
    # Implies that on refresh of web browser tab/window, searchString is read from these params in the url
    */


    ReportSearchPage.prototype.getSearchStringFromUrlParams = function() {
      var decode, getSearchString, match, paramKey, pl, query, searchParam, searchParamKeys, searchString, urlParamKeys, urlParams, _i, _len;
      pl = /\+/g;
      searchParam = /([^&=]+)=?([^&]*)/g;
      decode = function(s) {
        return decodeURIComponent(s.replace(pl, " "));
      };
      query = window.location.search.substring(1);
      urlParams = {};
      while ((match = searchParam.exec(query))) {
        urlParams[decode(match[1])] = decode(match[2]);
      }
      if (urlParams != null) {
        urlParamKeys = Object.keys(urlParams);
        searchParamKeys = ['name', 'amount', 'ledger', 'after', 'before', 'more', 'less', 'id'];
        searchString = '';
        getSearchString = function(paramKey) {
          var paramValue;
          if ($.inArray(paramKey, searchParamKeys) > -1) {
            paramValue = $.trim(urlParams[paramKey]);
            if (paramValue.split(' ').length > 1) {
              return searchString += "" + paramKey + ": \"" + paramValue + "\" ";
            } else {
              return searchString += "" + paramKey + ": " + paramValue + " ";
            }
          }
        };
        for (_i = 0, _len = urlParamKeys.length; _i < _len; _i++) {
          paramKey = urlParamKeys[_i];
          getSearchString(paramKey);
        }
      }
      return searchString;
    };

    ReportSearchPage.prototype.getDownloadUrl = function() {
      var clientId, encodedSearchString, endDate, intervalAsDates, isEnhancedSearchString, parameters, query, startDate, url;
      clientId = core.getCurrentClientId();
      encodedSearchString = encodeURIComponent(this.searchString.replace(/"|'/g, ''));
      parameters = this.getQueryParamsForTransactionsLoading(null, !!this.searchString);
      query = this.getQueryUrl(this.data.currentLedgerId, parameters, this.searchString);
      query = query.split('?')[1];
      isEnhancedSearchString = !query.includes('pattern=');
      url = location.apiRoot + location.reportingApiPath + (isEnhancedSearchString ? "query/xls/" + clientId + "?" + query : (intervalAsDates = rangeSelector.getIntervalAsDates(), endDate = intervalAsDates.to.toString('yyyy-MM-dd'), startDate = intervalAsDates.from.toString('yyyy-MM-dd'), this.data.currentLedgerId != null ? "search/xls/" + clientId + "/" + this.data.currentLedgerId + "/" + startDate + "/" + endDate + "?pattern=" + encodedSearchString : "search/xls/" + clientId + "/" + startDate + "/" + endDate + "?pattern=" + encodedSearchString));
      return url;
    };

    /*
    # By default data in the Search page should be editable, see BMA-1611 for more details
    */


    ReportSearchPage.prototype.isCurrentReportFinished = function() {
      this.$el.removeClass('status-finished');
      return false;
    };

    ReportSearchPage.prototype.dateChangeAction = function() {
      var preDateParams;
      this.changeDownloadUrl();
      preDateParams = [];
      if (this.data.currentLedgerId) {
        preDateParams.push(this.data.currentLedgerId);
      }
      this.updateReportURLFromInterval(preDateParams);
      return this.loadData(1, this.searchString);
    };

    return ReportSearchPage;

  })(TransactionsReportView);
});
